// @flow

export const KLADR_REGIONS_MOSCOW = '77';
export const KLADR_REGIONS_SEVASTOPOL = '92';
export const KLADR_REGIONS_ST_PETERSBURG = '78';
export const KLADR_REGIONS_BAIKONUR = '99';

export const FEDERAL_SIGNIFICANCE_CITIES = [
	KLADR_REGIONS_MOSCOW,
	KLADR_REGIONS_SEVASTOPOL,
	KLADR_REGIONS_ST_PETERSBURG,
	KLADR_REGIONS_BAIKONUR,
];
